export const SET_MODULE_STATE = 'SIDEBAR/MODULE/SET_STATE';
export const ACTIVATE_MODULE = 'SIDEBAR/MODULE/ACTIVATE';
export const SHOW_CHILDREN = 'SIDEBAR/MODULE/SHOW_CHILDREN';
export const HIDE_CHILDREN = 'SIDEBAR/MODULE/HIDE_CHILDREN';
export const DEACTIVATE_MODULE = 'SIDEBAR/MODULE/DEACTIVATE';
